import React from "react";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";

export default function DistributedComputing(authenticatedResources) {
  return (
    <div className="max-w-2xl mx-auto p-4">
      <h1 className="text-2xl font-bold mb-2">
        Distributed Computing Management System
      </h1>

      <div className="mb-2 flex items-center space-x-2 text-indigo-500 font-medium text-sm">
        <a
          href={authenticatedResources.sample}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1"
        >
          Proposal Document{" "}
          <ArrowTopRightOnSquareIcon className="w-4 h-4 inline" />
        </a>
      </div>

      <div className="mb-2 text-gray-700">
        This system manages distributed LLM training jobs across a
        high-performance computing cluster. It automates the fine-tuning of
        hundreds of large language models and coordinates $475,000 worth of
        compute resources, making it easy to run and monitor experiments at
        scale.
      </div>

      <span className="inline-flex flex-wrap gap-2 mb-8">
        <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-blue-100 text-blue-700 border border-blue-200">
          Python
        </span>
        <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-blue-100 text-blue-700 border border-blue-200">
          Bash
        </span>
        <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-blue-100 text-blue-700 border border-blue-200">
          JavaScript
        </span>
        <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-700 border border-green-200">
          React.js
        </span>
        <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-700 border border-green-200">
          System Design
        </span>
        <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-700 border border-green-200">
          Infrastructure
        </span>
        <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-700 border border-green-200">
          Linux
        </span>
      </span>
      <div className="mb-6">
        <h2 className="font-semibold text-base mb-1">Components</h2>
        <ul className="list-disc ml-6 text-gray-700">
          <li>
            Superagent (lab server): Collects and distributes sensitive data
          </li>
          <li>External API: Job management and across-network communication</li>
          <li>
            HPC Cluster Agent: Executes and manages distributed training jobs
          </li>
          <li>
            React Dashboard: Maintenance, debugging, and real-time status
            reports
          </li>
        </ul>
      </div>

      <div className="mb-6">
        <h2 className="font-semibold text-base mb-1">Features</h2>
        <ul className="list-disc ml-6 text-gray-700">
          <li>Automated parallel fine-tuning of hundreds of LLMs</li>
          <li>Secure data collection and distribution via superagent</li>
          <li>
            Centralized job management and monitoring through external API
          </li>
          <li>
            Real-time cluster status and job reporting via React dashboard
          </li>
          <li>Designed for scalability and secure multi-user access</li>
        </ul>
      </div>
    </div>
  );
}
